import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns}, minmax(0, 1fr));
  gap: ${props => props.theme.spacing.sp16};
`
